import { useParams } from "@tanstack/react-router";

interface ChatParams {
  id: string;
  uuid: string;
}

export const useChatParams = (): ChatParams => {
  const params = useParams({ strict: false });

  return {
    uuid: params.uuid ?? "",
    id: params.id ?? "",
  };
};
